var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDesktopIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.94291 6.85714C4.93302 6.85714 4.11434 7.67582 4.11434 8.68571V23.3143C4.11434 24.3242 4.93302 25.1429 5.94291 25.1429H26.0572C27.0671 25.1429 27.8858 24.3242 27.8858 23.3143V8.68571C27.8858 7.67582 27.0671 6.85714 26.0572 6.85714H5.94291ZM2.28577 8.68571C2.28577 6.66592 3.92313 5.02856 5.94291 5.02856H26.0572C28.077 5.02856 29.7143 6.66592 29.7143 8.68571V23.3143C29.7143 25.3341 28.077 26.9714 26.0572 26.9714H5.94291C3.92312 26.9714 2.28577 25.3341 2.28577 23.3143V8.68571Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5143 28.8C10.5143 28.2951 10.9236 27.8857 11.4286 27.8857H20.5714C21.0764 27.8857 21.4857 28.2951 21.4857 28.8C21.4857 29.305 21.0764 29.7143 20.5714 29.7143H11.4286C10.9236 29.7143 10.5143 29.305 10.5143 28.8Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopIcon);
export default __webpack_public_path__ + "static/media/desktop-icon.2f26a845.svg";
export { ForwardRef as ReactComponent };